export const SUBSCRIPTION_CANCELLED_KEY = 'sevalla-subscription-cancelled'
